import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cn } from "#/lib/utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Input = /*#__PURE__*/React.forwardRef((t0, ref) => {
  const $ = _c(18);
  let className;
  let error;
  let props;
  let type;
  if ($[0] !== t0) {
    ({
      className,
      type,
      error,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = error;
    $[3] = props;
    $[4] = type;
  } else {
    className = $[1];
    error = $[2];
    props = $[3];
    type = $[4];
  }
  const t1 = error && "border-red-500 focus-visible:ring-red-500";
  let t2;
  if ($[5] !== className || $[6] !== t1) {
    t2 = cn("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50", t1, className);
    $[5] = className;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props || $[9] !== ref || $[10] !== t2 || $[11] !== type) {
    t3 = /*#__PURE__*/_jsx("input", {
      type: type,
      className: t2,
      ref: ref,
      ...props
    });
    $[8] = props;
    $[9] = ref;
    $[10] = t2;
    $[11] = type;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== error) {
    t4 = error && /*#__PURE__*/_jsx("p", {
      className: "text-sm text-red-500",
      children: error
    });
    $[13] = error;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-1",
      children: [t3, t4]
    });
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
});
Input.displayName = "Input";
export { Input };